import React, { useRef } from 'react';
import { Journey } from 'src/common/interfaces/journey.interface';
import { NeueJourneyButton } from '../components/neue-button/journey';
import { TalkToJourneyPanel } from './panel';
import { LayoutMode } from '../types';
import { functionNoop } from 'src/utils/function/noop';
import { TalkToJourneyMessage } from './types';
import { CommentStrongIcon, SparklesStrongIcon } from 'src/monet/icons';
import { NeueCanvasButton } from '../components/neue-button/canvas';

export const TalkToJourneyButton = ({
  journeyUUID,  
  onSourceClick,
  findBlockByContentUuid,
  findSectionById,
  layoutMode,
  inEditor = false,
}: {
  journeyUUID: Journey['uuid']
  onSourceClick?: (message: TalkToJourneyMessage) => void;
  findBlockByContentUuid: (uuid: string) => any;
  findSectionById: (id: string) => any;
  layoutMode: LayoutMode;
  inEditor?: boolean;
}) => {
  const openRef = useRef(functionNoop);
  const closeRef = useRef(functionNoop);

  const onAskClick = () => {
    openRef.current?.();    
  }

  return (
    <>
      <NeueCanvasButton
        className="py-[5px] px-2.5"
        type='button'
        onClick={onAskClick}>
        <div className="flex items-center space-x-[6px]">
          <span>{layoutMode === 'web' ? 'Ask anything' : 'Ask'}</span>
          <SparklesStrongIcon />
        </div>        
      </NeueCanvasButton>
      <TalkToJourneyPanel
        layoutMode={layoutMode}
        journeyUUID={journeyUUID}
        openRef={openRef}
        closeRef={closeRef}
        onSourceClick={onSourceClick}
        findBlockByContentUuid={findBlockByContentUuid}
        findSectionById={findSectionById}
        inEditor={inEditor}
      />
    </>
  )
}